// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useUtilityAutomationClient } from '../../../contexts/UtilityAutomationApiContext';
import { UtilityBackend } from '../../../utils/UtilityAutomationApiClient';

const useTriggerNames = (backend: UtilityBackend): UseQueryResult<string[], string> => {
  const deadTaskClient = useUtilityAutomationClient();
  return useQuery({
    queryKey: ['triggerNames', deadTaskClient, backend],
    queryFn: async () => {
      return deadTaskClient.triggers(backend);
    },
  });
};

export default useTriggerNames;
